import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Podcastlisting(porps) {
  return (
    <div className="podcast_listing tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
            <div className="example" data-text="Podcast Ep">
              <h2>Latest Episodes</h2>
            </div>
            <p>
              We collaborate with entrepreneurs and industry leaders to
              emphasize the importance of digital transformation. We regularly
              invite technopreneurs and change leaders to talk about how
              technology played a crucial role in transforming their businesses
              and how it helps them scale up with sustainability.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="podcast_list">
              <h4>Mr. Hani Masgidi, Founder of Info Media Consultancy</h4>
              <div className="podcast_txt">
                <p>
                  Discussing the topic “From necessity to global standards, how
                  digital technology is reshaping businesses in the MENA
                  region”...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep2"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="podcast_list">
              <h4>Managing Partner of Tekrevol Daniel Burgess</h4>
              <div className="podcast_txt">
                <p>
                  In Season 2 Episode#1 of Technology For Change, Managing
                  Partner of Tekrevol Daniel Burgess discusses the role of
                  technology...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-season2-ep1"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="podcast_list">
              <h4>
                How Can Technology Implementations Improve Educational
                Institution Processes?
              </h4>
              <div className="podcast_txt">
                <p>
                  Tekrevol's Managing Partner Daniel Burgess is joined by
                  Lillian Row, a Baltimore County Board of Education member...
                </p>
              </div>
              <Link
                to="/podcast/technology-for-change-ep8"
                className="btn_podcast"
              >
                {" "}
                Listen to this Episode
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Podcastlisting;
